import { render, staticRenderFns } from "./ModalExcluirColaboracao.vue?vue&type=template&id=29577857&scoped=true"
import script from "./ModalExcluirColaboracao.vue?vue&type=script&lang=js"
export * from "./ModalExcluirColaboracao.vue?vue&type=script&lang=js"
import style0 from "./ModalExcluirColaboracao.vue?vue&type=style&index=0&id=29577857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29577857",
  null
  
)

export default component.exports